import { atom } from "jotai";

/**
 * Atom to control whether AI toolkit debug mode is enabled.
 * When enabled, this shows detailed information about tool calls,
 * AI responses, and other internal AI toolkit operations.
 * Can be toggled from browser devtools for debugging purposes.
 */
export const showDebugAtom = atom<boolean>(false);

showDebugAtom.debugLabel = "showDebugAtom";
